import { render, staticRenderFns } from "./estudantesPorEscolaRegional.vue?vue&type=template&id=04bd79e9"
import script from "./estudantesPorEscolaRegional.vue?vue&type=script&lang=js"
export * from "./estudantesPorEscolaRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports